/* tslint:disable */

declare var Object: any;
export interface CurrencyInterface {
  base_currency_code: string;
  createdby?: string;
  currency_code: string;
  exchange_value: number;
  lastupdatedby?: string;
  timestamp: string;
  id?: any;
  createdAt: Date;
  updatedAt: Date;
}

export class Currency implements CurrencyInterface {
  base_currency_code: string;
  createdby: string;
  currency_code: string;
  exchange_value: number;
  lastupdatedby: string;
  timestamp: string;
  id: any;
  createdAt: Date;
  updatedAt: Date;
  constructor(data?: CurrencyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Currency`.
   */
  public static getModelName() {
    return "Currency";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Currency for dynamic purposes.
  **/
  public static factory(data: CurrencyInterface): Currency{
    return new Currency(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Currency',
      plural: 'currencies',
      properties: {
        base_currency_code: {
          name: 'base_currency_code',
          type: 'string'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        currency_code: {
          name: 'currency_code',
          type: 'string'
        },
        exchange_value: {
          name: 'exchange_value',
          type: 'number'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        timestamp: {
          name: 'timestamp',
          type: 'string'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Currency.ts